"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const switchBuilder = () => ({ entryVars: { case: entryCases, value, }, functionId, callbacks, executeProcesses, }) => {
    if (typeof entryCases !== 'object') {
        return undefined;
    }
    const cases = entryCases || {};
    const condition = Object.entries(cases).find(([, caseValue]) => caseValue === value);
    if (condition) {
        const [caseKey, caseValue] = condition;
        executeProcesses(functionId, callbacks[caseKey], caseValue);
        return caseValue;
    }
    executeProcesses(undefined, callbacks.onDefault);
    return undefined;
};
exports.default = switchBuilder;
